module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_fwal.22f794f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_fwal.png
// module id = DhCM
// module chunks = 21